import { render, staticRenderFns } from "./goods_combine.vue?vue&type=template&id=55a098f2&scoped=true"
import script from "./goods_combine.vue?vue&type=script&lang=js"
export * from "./goods_combine.vue?vue&type=script&lang=js"
import style0 from "./goods_combine.vue?vue&type=style&index=0&id=55a098f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a098f2",
  null
  
)

export default component.exports